module.exports = __webpack_public_path__ + "static/media/Manual_DocsMatOPL.ab0f19ee.pdf";